// extracted by mini-css-extract-plugin
export default {"container":"vj-z","blurb":"wj-z","links":"xj-z"};